import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import getPrivacyPolicy from '../apis/getPrivacyPolicy'
import Privacy from '../components/dynamicdata/Privacy'
import About from '../components/dynamicdata/About'
import getAboutApp from '../apis/getAboutApp'

const Dynamic = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)

  const query = new URLSearchParams(location.search)
  const type = query.get('type') || 'about-us'

  const fetchData = useCallback(async () => {
    setLoading(true)
    if (type === 'about-us') {
      try {
        const about = await getAboutApp()
        console.log('Failed ddd to fetch', about)
        setData(about)
      } catch (error) {
        console.error('Failed to fetch', error)
      } finally {
        setLoading(false)
      }
    } else {
      const privacy = await getPrivacyPolicy()
      setData(privacy)
      try {
      } catch (error) {
        console.error('Failed to fetch', error)
      } finally {
        setLoading(false)
      }
    }
  }, [type])

  const refresh = () => {
    fetchData()
  }

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const handleTabClick = (newType) => {
    navigate(`/dynamic-content?type=${newType}`)
  }

  return (
    <>
      <div className="text-2xl text-blue-600 mb-4">Dynamic Content</div>
      <div className="flex space-x-4 ">
        <button
          className={`py-2 px-4  ${
            type === 'about-us'
              ? 'bg-blue-600 text-blueButton border-b-[2px] border-b-darkBlue'
              : ' text-gray'
          }`}
          onClick={() => handleTabClick('about-us')}
        >
          About Us
        </button>
        <button
          className={`py-2 px-4  ${
            type === 'privacy-policy'
              ? 'bg-blue-600 text-blueButton border-b-[2px] border-b-darkBlue '
              : 'text-gray'
          }`}
          onClick={() => handleTabClick('privacy-policy')}
        >
          Privacy Policy
        </button>
      </div>
      <div className="">
        {loading ? (
          <div>loading ... </div>
        ) : (
          <>
            {type === 'about-us' ? (
              <About data={data[0]} refresh={refresh} />
            ) : (
              <Privacy data={data} refresh={refresh} />
            )}
          </>
        )}
      </div>
    </>
  )
}

export default Dynamic
